import './brands.component.scss'

import 'swiper/css'
import 'swiper/css/pagination'

import Swiper, { Pagination } from 'swiper'

class BrandsSlider {
  constructor(elements) {
    this.elements = elements

    this.breakpoint = 768

    this.init()
  }

  defineSlider() {
    this.slider = new Swiper(this.elements.slider, {
      modules: [Pagination],
      spaceBetween: 24,
      slidesPerView: 1,
      autoHeight: true,
      pagination: {
        el: this.elements.pagination,
        type: 'bullets',
        clickable: true
      },
      breakpoints: {
        480: {
          slidesPerView: 2,
        },
        667: {
          slidesPerView: 3,
        },
      }
    })
  }

  toggleSlider(event) {
    if (event) {
      if (event.matches) {
        if (this.slider) {
          this.slider.destroy()
          this.slider = null
        }
      } else {
        this.defineSlider()
      }
    } else {
      if (window.innerWidth < this.breakpoint) {
        this.defineSlider()
      }
    }
  }

  init() {
    this.toggleSlider()

    const media = `(min-width: ${this.breakpoint}px)`
    const mediaWatcher = window.matchMedia(media)
    mediaWatcher.addEventListener('change', this.toggleSlider.bind(this)) 
  }
}

const brandsSliderEl = document.querySelector('.brands__slider')
if (brandsSliderEl) {
  new BrandsSlider({
    slider: brandsSliderEl,
    pagination: brandsSliderEl.querySelector('.swiper-pagination')
  })
}